<template>
    <div class="header_auto_search" v-if="isShown">
        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="title">
                        <div class="found-count">{{ count }} found</div>
                        <a :href="`catalog?s=${value}`" class="view-all-link">View all</a>
                    </div>
                    <div class="showcase" v-loading="loading">
                        <div class="item" v-for="item in items">
                            <a :href="item.permalink" class="item-thumb">
                                <img class="lazy" :data-src="itemImage(item)" :alt="item.title">
                            </a>
                            <div>
                                <a :href="item.permalink" class="item-name">{{ item.title }}</a>
                                <div class="item-price">{{ item.formatted_price }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data: () => ({
        items: [],
        count: 0,
        value: '',
        isShown: false,
        loading: false
    }),
    watch: {
        isShown(next) {
            if (next) {
                document.querySelector('html').style.overflow = 'hidden'
            } else {
                document.querySelector('html').style.overflow = ''
            }
        }
    },
    mounted() {
        document.addEventListener('app::auto-search', this.updateFoundItems)
        document.addEventListener('app::auto-search-show', this.show)
        document.addEventListener('app::auto-search-close', this.close)
    },
    methods: {
        async updateFoundItems(ev) {
            const value = ev.value

            this.isShown = true

            if (value) {
                this.loading = true
                const items = await axios.get('/api/v1/products?search=' + value)

                this.value = value
                this.items = items.data?.data?.slice(0, 4) || []
                this.count = items.data?.meta?.pagination?.total || 0
                this.loading = false
                return
            }

            this.value = ''
            this.count = 0
            this.items = []
        },
        show() {
            this.isShown = true
        },
        close() {
            this.isShown = false
        },
        itemImage(item) {
            return item.defaultVariant?.data?.images?.data?.[0]?.url || item.image
        }
    }
}
</script>
